<template>
	<div
		class="app-wrapper"
		:class="routeClass"
	>
		<Header />
		<div class="app-wrapper__content">
			<router-view v-if="!loading" />
			<LoadingSpinner
				v-else
				class="app-wrapper__loading-spinner"
			/>
		</div>
	</div>
</template>

<script>
import Header from '@videotools/js/analysis/modules/Header/Header';
import LoadingSpinner from '@shared/components/LoadingSpinner';
import { mapActions } from 'vuex';

export default {
	name:       'App',
	components: { Header, LoadingSpinner },
	data() {
		return {
			loading: true,
		};
	},
	computed: {
		routeClass() {
			return this.$route.name ? `is-${this.$route.name.toLowerCase()}` : '';
		},
	},
	async created() {
		this.loading = true;
		try {
			const syncInitPromise = this.syncInit();
			const eventPromise = this.loadEvent({ id: this.$route.params.id });
			await Promise.all([syncInitPromise, eventPromise]);

			// dependent on event and sync
			const tagGroupsPromise = this.initTagGroups();
			const syncSetupPromise = this.syncSetup();
			await Promise.all([tagGroupsPromise, syncSetupPromise]);
		} catch (error) {
			console.log('Initialization error:', error);
		} finally {
			this.loading = false;
		}
	},
	methods: {
		...mapActions({
			loadEvent:     'event/loadEvent',
			initTagGroups: 'tagGroups/init',
			syncInit:      'sync/init',
			syncSetup:     'sync/setup',
		}),
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

*, *::before, *::after {
	box-sizing: border-box;
}

.app-wrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	background: var(--color-black);
	color: var(--color-soft-white);

	&.is-taggingtool {
		overflow: hidden;
	}

	&.is-highlight {
		height: 100vh;
		overflow: hidden;
	}
}

.app-wrapper__content {
	@include z-index('asport-one-content-wrapper', 'global');
	position: relative;
	flex-grow: 1;
	min-height: 0;
}

.app-wrapper__loading-spinner {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
</style>
